import { useQuery } from '@tanstack/react-query'
import { LayoutDashboard, Store } from 'lucide-react'
import { Outlet } from 'react-router-dom'
import { AdminSidebar, type NavItem } from '@/components/admin/sidebar'
import { EpicToaster } from '@/components/ui/sonner'
import { adminApi } from '@/lib/admin-api'

const NAV_ITEMS: NavItem[] = [
	{
		to: '/admin',
		label: 'Dashboard',
		icon: LayoutDashboard,
		end: true,
	},
	{
		to: '/admin/branches',
		label: 'Branches',
		icon: Store,
	},
]

export function AdminLayout() {
	const meQuery = useQuery({
		queryKey: ['admin', 'me'],
		queryFn: adminApi.me,
		staleTime: 5 * 60_000,
	})

	return (
		<div className="min-h-screen bg-gray-50">
			<AdminSidebar items={NAV_ITEMS} user={meQuery.data} />
			<main className="lg:pl-64 pt-14 lg:pt-0 min-h-screen">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
					<Outlet />
				</div>
			</main>
			<EpicToaster />
		</div>
	)
}
